<template>
  <EditorButton :title="$t('video')">
    <template v-slot:trigger="{ hide, show }">
      <MPopover
        ref="popover"
        placement="bottomRight"
        :overlay-style="{ width: '300px' }"
        @show="handlePopoverShow"
      >
        <template v-slot:trigger>
          <MButton
            variant="transparent"
            class="small-icon-button"
            :shadow="false"
            @mouseenter="show"
            @mouseleave="hide"
          >
            <slot />
          </MButton>
        </template>
        <FlotoForm @submit="handleFormSubmit">
          <FlotoFormItem
            ref="input"
            v-model="url"
            :label="`${$tc('video')} ${$tc('link')}`"
            rules="required|url"
            placeholder="http://youtube.com/embed/xxx"
            @keydown.esc="hideMenu"
          />
          <template v-slot:submit>
            <div class="flex justify-end">
              <MButton type="submit" size="small" class="mx-1">
                {{ $t('add') }}
              </MButton>
              <MButton size="small" variant="default" @click="hideMenu">
                {{ $t('cancel') }}
              </MButton>
            </div>
          </template>
        </FlotoForm>
      </MPopover>
    </template>
  </EditorButton>
</template>

<script>
import EditorButton from './editor-button'
export default {
  name: 'EmbedButton',
  components: { EditorButton },
  data() {
    return {
      url: '',
    }
  },
  methods: {
    handlePopoverShow() {
      setTimeout(() => {
        this.$refs.input.focus()
      }, 250)
    },
    handleFormSubmit() {
      this.$emit('add', this.url)
      this.hideMenu()
    },
    hideMenu() {
      this.$emit('hide')
      this.$refs.popover.hide()
    },
  },
}
</script>
